module.exports = __webpack_public_path__ + "img/CDISCOUNT_80X30.1d08417a.png";